import { isSsoOAuthClientIdConfigured } from "@Front/integrations/oauth-default/ssoOAuthBrowserUrls";
import type { PublicSiteIntegrationFlags } from "@Front/Services/PublicSiteConfig/publicSiteConfigLoader";
import type { PublicSsoOauthLoginPresetLoaded } from "@Front/Services/PublicSiteConfig/publicSiteConfigLoader";

export type StepEmailSsoUiFlags = {
	showSsoOauthLoginPresetPicker: boolean;
	showSsoProfessionalBlock: boolean;
};

export function computeStepEmailSsoUiFlags(params: {
	ready: boolean;
	flags: PublicSiteIntegrationFlags;
	sso_oauth_client_id: string | null;
	__DATA_SSO_OAUTH_LOGIN_PRESETS__: readonly PublicSsoOauthLoginPresetLoaded[] | null;
	isEnsoPublicLine: boolean;
}): StepEmailSsoUiFlags {
	const { ready, flags, sso_oauth_client_id, __DATA_SSO_OAUTH_LOGIN_PRESETS__, isEnsoPublicLine } = params;
	const ssoOAuthReady = computeSsoOAuthReady(ready, flags.uses_sso_oauth, sso_oauth_client_id);
	const presetCount = __DATA_SSO_OAUTH_LOGIN_PRESETS__?.length ?? 0;
	const showSsoOauthLoginPresetPicker = computeShowPresetPicker(isEnsoPublicLine, ssoOAuthReady, presetCount);
	const showSsoProfessionalBlock = computeShowSsoProBlock(ssoOAuthReady, isEnsoPublicLine, presetCount);
	return { showSsoOauthLoginPresetPicker, showSsoProfessionalBlock };
}

function computeSsoOAuthReady(ready: boolean, usesSso: boolean, clientId: string | null): boolean {
	return ready && usesSso && isSsoOAuthClientIdConfigured(clientId);
}

function computeShowPresetPicker(isEnsoPublicLine: boolean, ssoOAuthReady: boolean, presetCount: number): boolean {
	return !isEnsoPublicLine && ssoOAuthReady && presetCount > 0;
}

function computeShowSsoProBlock(ssoOAuthReady: boolean, isEnsoPublicLine: boolean, presetCount: number): boolean {
	return ssoOAuthReady && (isEnsoPublicLine || presetCount === 0);
}
